<template>
  <el-dialog
    id="InvoiceAddOrUpdate"
    :title="disabled?'发票详情':'开具发票'"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="30%">
    <el-row>
      <el-col :span="24">
        <el-form ref="dataForm" :model="invoiceObj" :rules="dataRule" label-width="80px" id="dataForm">
          <el-form-item label="开票状态" prop="status"
                        :rules="[
                          { required: true, message: '开票状态不能为空' }
                        ]"
                        v-if="disabled">
            <el-input :disabled="disabled" :value="statusTag(statusOptions, invoiceObj.status)"></el-input>
          </el-form-item>
          <el-form-item label="抬头类型" prop="userType"
                        :rules="[
                          { required: true, message: '抬头类型不能为空' }
                        ]">
            <el-select v-model="invoiceObj.userType" @change="e => changeRule('userType', e)" :disabled="disabled">
              <el-option label="个人" value="0"></el-option>
              <el-option label="企业" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发票类型" prop="invoiceType" v-if="invoiceObj.userType == '1'"
                        :rules="[
                          { required: true, message: '发票类型不能为空' }
                        ]">
            <el-select v-model="invoiceObj.invoiceType" @change="e => changeRule('invoiceType', e)" :disabled="disabled">
              <el-option label="普通发票" value="0"></el-option>
              <!--<el-option label="专用发票" value="1"></el-option>-->
            </el-select>
          </el-form-item>
          <el-form-item label="发票抬头" prop="invoice"
                        :rules="[
                          { required: true, message: '发票抬头不能为空' },
                          { max: 30, message: '长度不能超过30个字符' }
                        ]">
            <el-autocomplete
              v-if="invoiceObj.userType == '1'"
              v-model="invoiceObj.invoice"
              :fetch-suggestions="querySearchInvoice"
              @select="handleSelectInvoice"
              :disabled="disabled">
              <template slot-scope="{ item }">
                <div class="autocompleteInvoice">
                  <div class="name">
                    <p>{{ item.value }}</p>
                    <p class="tin">{{ item.tin }}</p>
                  </div>
                  <div class="reported">
                    <a v-if="item.status === -1" style="color: #8b8b8b;">已上报</a>
                    <a v-else @click="reportedHandle(item, item.id)">错误上报</a>
                  </div>
                </div>
              </template>
            </el-autocomplete>
            <el-input v-else v-model="invoiceObj.invoice" :disabled="disabled"></el-input>
          </el-form-item>
          <!--企业类型-->
          <template v-if="invoiceObj.userType == '1'">
            <el-form-item label="税号" prop="tin"
                          :rules="[
                            { required: true, message: '税号不能为空' },
                            { max: 20, message: '长度不能超过20个字符' }
                          ]">
              <el-input v-model="invoiceObj.tin" :disabled="disabled"></el-input>
            </el-form-item>
            <!--专用类型-->
            <template v-if="invoiceObj.invoiceType == '1'">
              <el-form-item label="开户银行" prop="bankDeposit"
                            :rules="[
                              { required: true, message: '开户银行不能为空' },
                              { max: 50, message: '长度不能超过50个字符' }
                            ]">
                <el-input v-model="invoiceObj.bankDeposit" :disabled="disabled"></el-input>
              </el-form-item>
              <el-form-item label="银行账号" prop="bankAccount"
                            :rules="[
                              { required: true, message: '银行账号不能为空' },
                              { max: 20, message: '长度不能超过20个字符' }
                            ]">
                <el-input v-model="invoiceObj.bankAccount" :disabled="disabled"></el-input>
              </el-form-item>
              <el-form-item label="企业地址" prop="address"
                            :rules="[
                              { required: true, message: '企业地址不能为空' },
                              { max: 100, message: '长度不能超过100个字符' }
                            ]">
                <el-input v-model="invoiceObj.address" :disabled="disabled"></el-input>
              </el-form-item>
              <el-form-item label="企业电话" prop="mobile"
                            :rules="[
                              { required: true, message: '企业电话不能为空' },
                              { max: 20, message: '长度不能超过20个字符' }
                            ]">
                <el-input v-model="invoiceObj.mobile" :disabled="disabled"></el-input>
              </el-form-item>
            </template>
          </template>
          <el-form-item label="寄送类型" prop="sendType"
                        :rules="[
                          { required: true, message: '寄送类型不能为空' }
                        ]">
            <el-select v-model="invoiceObj.sendType" @change="e => changeRule('', e)" :disabled="disabled">
              <!--<el-option label="货票同行" value="0"></el-option>-->
              <!--<el-option label="货票分离" value="1"></el-option>-->
              <el-option label="电子发票" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="接收方式" prop="invoiceReceiveValue"
                        v-if="invoiceObj.sendType === '2'"
                        :rules="invoiceObj.invoiceReceiveType == 0 ? [
                                    { required: true, message: '接收方式不能为空' },
                                    { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                                  ] : [
                                    { required: true, message: '接收方式不能为空' },
                                    { pattern: /^1[0-9]{10}$/, message: '请输入正确的手机号', trigger: ['blur', 'change'] }
                                  ]">
            <el-input v-if="!disabled" placeholder="请输入" v-model="invoiceObj.invoiceReceiveValue">
              <el-select v-model="invoiceObj.invoiceReceiveType" slot="prepend" placeholder="请选择" style="width:90px">
                <!--<el-option label="邮箱" :value="0"></el-option>-->
                <el-option label="手机号" :value="1"></el-option>
              </el-select>
            </el-input>
            <el-input v-else v-model="invoiceObj.invoiceReceiveValue" :disabled="disabled"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <span slot="footer" v-if="!disabled">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="submit()">确 定</el-button>
    </span>
    <span slot="footer" v-if="disabled && invoiceObj.status === 1">
      <el-button type="primary" @click="download()">下载发票</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import axios from 'axios'

  export default {
    name: "invoice-add-or-update",
    data() {
      return {
        visible: false,
        orderNum: '',
        invoiceObj: {
          invoiceFlag: '0',
          userType: '0',
          invoiceType: '0',
          invoice: '',
          tin: '',
          bankDeposit: '',
          bankAccount: '',
          address: '',
          mobile: '',
          sendType: '2',
          invoiceReceiveType: 1,
          invoiceReceiveValue: '',
          status: 0
        },
        dataRule: {},
        disabled: false,
        statusOptions: [{
          value: 0,
          label: '未开票'
        }, {
          value: 1,
          label: '开票成功'
        }, {
          value: 2,
          label: '开票失败'
        }, {
          value: 3,
          label: '开票中'
        }, {
          value: 4,
          label: '重开失败'
        }]
      }
    },
    watch: {

    },
    computed: {
      user() {
        return this.$store.state.user;
      },
      statusTag () {
        return function (arr, code) {
          return (arr.find(e => e.value === code) || { label: '--' }).label
        }
      }
    },
    methods: {
      //初始化
      init (orderNum) {
        this.visible = true
        this.orderNum = orderNum
        this.dataRule = {}
        this.disabled = false
        this.getInvoiceInfo()
      },
      getInvoiceInfo() {
        let that = this
        axios.get('/jys/invoice/' + this.orderNum
        ).then((response) => {
          if (response.data.code === 0 && response.data.result) {
            let res = response.data.result
            that.invoiceObj = {
              id: res.id,
              invoiceFlag: '1',
              userType: res.userType + '',
              invoiceType: res.invoiceType + '',
              invoice: res.invoice,
              tin: res.tin,
              bankDeposit: res.bankDeposit,
              bankAccount: res.bankAccount,
              address: res.address,
              mobile: res.mobile,
              sendType: res.sendType + '',
              invoiceReceiveType: res.invoiceReceiveType,
              invoiceReceiveValue: res.invoiceReceiveValue,
              status: res.status
            }
            that.disabled = true
          } else {
            this.changeRule('invoiceFlag', '1')
          }
          this.$nextTick(() => {
            setTimeout(() => {
              this.$refs['dataForm'].clearValidate()
            }, 1)
          })
        })
      },
      submit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            axios.post("/jys/invoice/appl", {
              orderNum: this.orderNum,
              ...this.invoiceObj
            }).then((response) => {
              this.visible = false
              this.$emit('refreshDataList')
            })
          }
        })
      },
      // 校验规则
      changeRule (key, e) {
        // 设置值
        if (key) {
          if (key === 'invoiceFlag') {
            this.invoiceObj.userType = '0'
            this.invoiceObj.invoiceType = '0'
          } else if (key === 'userType') {
            this.invoiceObj.invoiceType = '0'
          }
          this.invoiceObj.invoice = ''
          this.invoiceObj.tin = ''
          this.invoiceObj.bankDeposit = ''
          this.invoiceObj.bankAccount = ''
          this.invoiceObj.address = ''
          this.invoiceObj.mobile = ''
          this.invoiceObj.sendType = '2'
          this.invoiceObj.invoiceReceiveType = 1
          this.invoiceObj.invoiceReceiveValue = ''
        }
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs['dataForm'].clearValidate()
          }, 1)
        })
      },
      // 下载发票
      download () {
        location.href = process.env.API_ROOT + "/jys/invoice/download/" + this.invoiceObj.id
      },
      //获取发票
      querySearchInvoice(queryString, cb) {
        if (queryString) {
          axios.get("/jys/invoice/store/list", {
            params: {
              limit: 10,
              page: 1,
              invoice: queryString
            }
          }).then((res) => {
            if (res.data.code === 0) {
              cb(JSON.parse(JSON.stringify(res.data.invoiceStoreList).replace(/invoice/g,"value")))
            }
          })
        } else {
          cb([])
        }
      },
      handleSelectInvoice(item) {
        this.invoiceObj.tin = item.tin
      },
      reportedHandle(item,id) {
        axios.put('/jys/invoice/store/reported/' + id, {
        }).then((response) => {
          if (response.data.code === 0) {
            this.$message({
              message: '上报成功',
              type: 'success'
            })
            item.status = -1
          }
        })
      }
    }
  }
</script>

<style scoped>
  #InvoiceAddOrUpdate >>> .el-dialog__header{
    text-align: center;
  }
  #InvoiceAddOrUpdate >>> .el-dialog__title{
    color: #000000;
    font-size: 17px;
    font-weight: bold;
  }
  #InvoiceAddOrUpdate .el-row{
    margin-bottom: 0;
  }
  /deep/ .el-form-item{
    width: 100%;
  }
  /deep/ .el-form-item__content{
    width: calc(100% - 100px);
  }
  /deep/ .el-select{
    width: 100%;
  }
  /deep/ .el-dialog__footer{
    text-align: center;
  }
  /deep/ .el-input.is-disabled .el-input__inner,
  /deep/ .el-textarea.is-disabled .el-textarea__inner{
    background-color: #ffffff;
    color: #606266;
    border: none;
    cursor: unset;
  }
  /deep/ .el-input.is-disabled .el-select__caret{
    display: none;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    /deep/ .el-dialog {
      width: 98%!important;
    }
  }
  /deep/ .el-autocomplete {
    width: 100%;
  }
  .autocompleteInvoice {
    margin: 5px 0;
  }
  .autocompleteInvoice .name {
    display: inline-block;
    width: calc(100% - 60px);
    vertical-align: middle;
    line-height: 20px;
  }
  .autocompleteInvoice .name p:first-child {
    white-space: pre-line;
  }
  .autocompleteInvoice .tin {
    font-size: 10px;
    color: #8b8b8b;
  }
  .autocompleteInvoice .reported {
    display: inline-block;
    width: 60px;
    vertical-align: middle;
    font-size: 11px;
    color: #999999;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/invoice-add-or-update.vue